export enum CompareBarAreaType { //eslint-disable-line @stencil-community/ban-exported-const-enums
  //FIXME CONST ENUM JEST ZABRONIONE
  CompareNowButton = 'compare_now',
  ClearList = 'clear_list'
}
